import actionTypes from '../constants/actionTypes';

const INITIAL_STATE = {
  isLoading: true,
  items: [],
  filterValue: '',
  error: null
};

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.LOAD_APPLICATIONS_START:
      return {
        ...state,
        isLoading: true,
        error: INITIAL_STATE.error
      };
    case actionTypes.LOAD_APPLICATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: action.payload
      };
    case actionTypes.LOAD_APPLICATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        items: [],
        error: action.payload
      };
    case actionTypes.FILTER_APPLICATIONS:
      return {
        ...state,
        filterValue: action.payload
      };
    default:
      return state;
  }
}

export default reducer;
